import React, { useState, useRef, useEffect } from "react";
import Select from "react-select";
import "../Style/Component/Personalinfo.css";
import eye from "../Assets/Account/eye.svg";
import camera from "../Assets/Account/camera.svg";
import profileimage from "../Assets/Account/7e751d11f30fc3b155d92b1f20a344fe52513f13.jpg";
import OtpModal from "./OtpModal";
import {
  deleteWithTokenAPI,
  getWithTokenAPI,
  postWithoutTokenAPI,
  postWithTokenAPI,
  putWithTokenAPI,
} from "../Util/Api";
import { useSelector } from "react-redux";
import SimpleRichEditor from "./SimpleRichEditor";
import { toast } from "react-toastify";
import { FaRegEye, FaRegEyeSlash } from "react-icons/fa6";
const Personalinfo = ({ profiledata, onApproveSuccess }) => {
  const [otpOpen, setOtpOpen] = useState(false);
  const [activeTab, setActiveTab] = useState("details");
  const [showNew, setShowNew] = useState(false);
  const [showConfirm, setShowConfirm] = useState(false);
  const [tcTab, setTcTab] = useState("preview");
  const [activeterms, setActiveTerms] = useState("Driver");
  const profileFileRef = useRef(null);
  const logoFileRef = useRef(null);
  const auth = useSelector((state) => state.auth);
  const token = auth.token;
  const adminId = auth.userId;
  const permission = auth.permission;
  /* ===== DROPDOWN DATA ===== */
  const [states, setStates] = useState([]);
  const [districts, setDistricts] = useState([]);

  const [form, setForm] = useState({});
  const [errors, setErrors] = useState({});
  const [loading, setLoading] = useState(false);
  const [pswd, setPswd] = useState(null);
  const [cpswd, setCPswd] = useState(null);
  const nameRegex = /^[a-zA-Z\s]{3,}$/;
  const phoneRegex = /^[6-9]\d{9}$/;
  const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
  // const ifscRegex = /^[A-Z]{4}0[A-Z0-9]{6}$/;
  const ifscRegex = /^[A-Z]{4}/;
  const accountRegex = /^\d{9,18}$/;

  useEffect(() => {
    if (profiledata) {
      setForm(mapProfileToForm(profiledata));
    }
  }, [profiledata]);

  useEffect(() => {
    if (form?.state?.value) {
      fetchDistricts(form.state.value);
    }
  }, [form?.state]);

  const fetchStates = async () => {
    try {
      const res = await fetch(
        "https://countriesnow.space/api/v0.1/countries/states",
        {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({ country: "India" }),
        },
      );

      const data = await res.json();

      const formatted = data.data.states.map((state) => ({
        label: state.name,
        value: state.name,
      }));

      setStates(formatted);
    } catch (error) {
      console.error("Failed to fetch states:", error);
    }
  };

  useEffect(() => {
    fetchStates();
  }, []);
  const [applogo, setApplogo] = useState("");
  const [logoid, setLogoId] = useState("");
  const [logoType, setLogoType] = useState({ label: "User", value: "user" });
  const fetchLogo = async () => {
    try {
      const res = await getWithTokenAPI(token, `/logo?type=${logoType.value}`);
      setApplogo(res?.data?.[0]?.logo || "");
      setLogoId(res?.data?.[0]?._id || "");
    } catch (error) {
      console.error("Failed to fetch logo:", error);
    }
  };
  useEffect(() => {
    fetchLogo();
  },[logoType]);

  const fetchDistricts = async (selectedState) => {
    try {
      const res = await fetch(
        "https://countriesnow.space/api/v0.1/countries/state/cities",
        {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({
            country: "India",
            state: selectedState,
          }),
        },
      );

      const data = await res.json();

      const formatted = data.data.map((city) => ({
        label: city,
        value: city,
      }));

      setDistricts(formatted);
    } catch (error) {
      console.error("Failed to fetch districts:", error);
    }
  };

  /* ===== GENERIC POLICY & CONTACT US MANAGEMENT COMPONENTS ===== */
  const PolicyListing = ({ list, defaultTitle }) => {
    const section = list?.sections || [];

    return (
      <div className="tc-listing">
        <h3>{list?.title || defaultTitle}</h3>
        {list?.description && (
          <p style={{ color: "#666", marginBottom: "15px" }}>{list.description}</p>
        )}

        {section.length === 0 ? (
          <p>No Sections Found</p>
        ) : (
          <div className="tc-sections">
            {section.map((item, index) => (
              <div key={index} className="tc-section">
                <h4>
                  {index + 1}. {item.heading}
                </h4>

                {item.points?.map((point, i) => (
                  <p key={i}> {point}</p>
                ))}
              </div>
            ))}
          </div>
        )}
      </div>
    );
  };

  const PolicyCreate = ({
    list,
    token,
    endpoint,
    policyTitle,
    activeterms,
    setTcTab,
    onRefresh,
  }) => {
    const [title, setTitle] = useState(list?.title || policyTitle);
    const [description, setDescription] = useState(list?.description || "");
    const [formData, setFormData] = useState([{ title: "", description: "" }]);
    const [expandedSection, setExpandedSection] = useState(0);

    useEffect(() => {
      if (list?._id) {
        setTitle(list.title || policyTitle);
        setDescription(list.description || "");
        if (Array.isArray(list?.sections)) {
          const mapped = list.sections.map((sec) => ({
            title: sec.heading || "",
            description: Array.isArray(sec.points) ? sec.points.join("\n") : "",
          }));

          setFormData(
            mapped.length > 0 ? mapped : [{ title: "", description: "" }]
          );
          setExpandedSection(0);
        }
      } else {
        setTitle(policyTitle);
        setDescription(`This is a dummy ${policyTitle.toLowerCase()}.`);
        setFormData([{ title: "", description: "" }]);
        setExpandedSection(0);
      }
    }, [list, policyTitle]);

    const toggleSection = (index) => {
      setExpandedSection((prevIndex) => (prevIndex === index ? null : index));
    };

    const handleAddSection = () => {
      setFormData((prev) => [...prev, { title: "", description: "" }]);
      setExpandedSection(formData.length);
    };

    const handleChange = (index, field, value) => {
      const updated = [...formData];
      updated[index][field] = value;
      setFormData(updated);
    };

    const handleRemove = (index) => {
      setFormData((prev) => prev.filter((_, i) => i !== index));
      setExpandedSection((prevIndex) => {
        if (prevIndex === index) {
          return formData.length > 1 ? Math.min(index, formData.length - 2) : null;
        } else if (prevIndex > index) {
          return prevIndex - 1;
        }
        return prevIndex;
      });
    };

    const handleDelete = async (id) => {
      if (!id) return;
      try {
        const response = await deleteWithTokenAPI(
          token,
          `/${endpoint}/delete/${id}`
        );

        if (response?.statusCode === 200 || response?.status) {
          toast.success(`${policyTitle} deleted successfully`);
          onRefresh && onRefresh();
          setTcTab("preview");
        } else {
          toast.error(
            response?.message || `Failed to delete ${policyTitle}`
          );
        }
      } catch (error) {
        console.error(`Error deleting ${policyTitle}:`, error);
        toast.error("Something went wrong while deleting");
      }
    };

    const handleSave = async () => {
      const sections = Array.isArray(formData)
        ? formData.map((item) => ({
            heading: item.title || "",
            points: item.description
              ? item.description.split("\n").filter((p) => p.trim() !== "")
              : [],
          }))
        : [];

      const payload = {
        title: title || policyTitle,
        description:
          description || `This is a dummy ${policyTitle.toLowerCase()}.`,
        type: activeterms.toLowerCase(),
        sections: sections,
        version: list?.version || "1.0",
        is_active: true,
      };

      try {
        if (list?._id) {
          const response = await putWithTokenAPI(
            token,
            `/${endpoint}/update/${list._id}`,
            payload
          );

          if (response?.statusCode === 200 || response?.status === "success") {
            onRefresh && onRefresh();
            setTcTab("preview");
            toast.success(`${policyTitle} updated successfully`);
          } else {
            toast.error(response?.message || `Failed to update ${policyTitle}`);
          }
        } else {
          const response = await postWithTokenAPI(
            token,
            `/${endpoint}/create`,
            payload
          );

          if (response?.statusCode === 200 || response?.status === "success") {
            onRefresh && onRefresh();
            setTcTab("preview");
            toast.success(`${policyTitle} created successfully`);
          } else {
            toast.error(response?.message || `Failed to create ${policyTitle}`);
          }
        }
      } catch (error) {
        console.error(`Error saving ${policyTitle}:`, error);
        toast.error(`Failed to save ${policyTitle}`);
      }
    };

    return (
      <div className="editor-container minimalist">
        <div className="tc-create-container">
          <div className="tc-create-container-chiled">
            <h3>
              {list?._id ? `Edit ${policyTitle}` : `Create ${policyTitle}`}
            </h3>
            <button className="btn btn-primary" onClick={handleAddSection}>
              + Add Section
            </button>
          </div>

          <div className="form-groupp" style={{ marginTop: "10px" }}>
            <label>Policy Title</label>
            <input
              type="text"
              value={title}
              onChange={(e) => setTitle(e.target.value)}
              className="form-input-title"
            />
          </div>

          <div className="form-groupp">
            <label>Policy Description</label>
            <input
              type="text"
              value={description}
              onChange={(e) => setDescription(e.target.value)}
              className="form-input-title"
            />
          </div>

          {formData.map((item, index) => (
            <div className="tc-form-card" key={index}>
              <div
                className="accordion-section-header"
                onClick={() => toggleSection(index)}
              >
                <div className="accordion-header-left">
                  <span className="accordion-toggle-icon">
                    {expandedSection === index ? "▼" : "▶"}
                  </span>
                  <h4>
                    Section {index + 1}
                    {item.title ? `: ${item.title}` : ""}
                  </h4>
                </div>

                {formData.length > 1 && (
                  <button
                    type="button"
                    className="btn btn-danger btn-small"
                    onClick={(e) => {
                      e.stopPropagation();
                      handleRemove(index);
                    }}
                  >
                    Cancel
                  </button>
                )}
              </div>

              {expandedSection === index && (
                <div className="accordion-section-content">
                  <div className="form-group">
                    <label>Title *</label>
                    <input
                      type="text"
                      value={item.title}
                      placeholder="Enter section title"
                      onChange={(e) =>
                        handleChange(index, "title", e.target.value)
                      }
                      className="form-input-title"
                    />
                  </div>

                  <SimpleRichEditor
                    key={index}
                    value={item.description}
                    index={index}
                    onChange={handleChange}
                  />
                </div>
              )}
            </div>
          ))}

          <div
            style={{
              marginTop: 20,
              display: "flex",
              justifyContent: "flex-end",
              gap: "10px",
            }}
          >
            {list?._id && (
              <button
                className="btn btn-danger delete-btn-teams"
                onClick={() => handleDelete(list?._id)}
              >
                Delete
              </button>
            )}

            <button className="btn btn-success" onClick={handleSave}>
              {list?._id ? `Update ${policyTitle}` : `Save ${policyTitle}`}
            </button>
          </div>
        </div>
      </div>
    );
  };

  const PolicyManager = ({ policyTitle, endpoint, token, permission }) => {
    const [tcTab, setTcTab] = useState("preview");
    const [activeterms, setActiveTerms] = useState("Driver");
    const [list, setList] = useState(null);
    const [loading, setLoading] = useState(false);

    const fetchPolicy = async () => {
      setLoading(true);
      try {
        const typeStr = activeterms.toLowerCase();
        const response = await getWithTokenAPI(
          token,
          `/${endpoint}/list?type=${typeStr}`
        );

        if (response?.statusCode === 200 && response?.data) {
          if (Array.isArray(response.data)) {
            const matched = response.data.find(
              (item) => item.type?.toLowerCase() === typeStr
            );
            setList(
              matched ||
                response.data[activeterms === "Driver" ? 0 : 1] ||
                response.data[0] ||
                null
            );
          } else {
            setList(response.data);
          }
        } else {
          setList(null);
        }
      } catch (error) {
        console.error(`Error fetching ${policyTitle}:`, error);
        setList(null);
      } finally {
        setLoading(false);
      }
    };

    useEffect(() => {
      fetchPolicy();
    }, [token, activeterms, endpoint]);

    return (
      <div className="tc-wrapper">
        <div className="tc-tabs">
          <div className="tc-tabs-child">
            <span
              className={`tc-tab ${activeterms === "Driver" ? "active" : ""}`}
              onClick={() => setActiveTerms("Driver")}
            >
              Driver
            </span>
            <span
              className={`tc-tab ${activeterms === "User" ? "active" : ""}`}
              onClick={() => setActiveTerms("User")}
            >
              User
            </span>
          </div>
          <div className="tc-tabs-child">
            <span
              className={tcTab === "preview" ? "tc-tab active" : "tc-tab"}
              onClick={() => setTcTab("preview")}
            >
              Preview
            </span>

            {permission?.logoandtermsCondition?.update && (
              <span
                className={tcTab === "create" ? "tc-tab active" : "tc-tab"}
                onClick={() => setTcTab("create")}
              >
                {list?._id ? "Edit" : "Create"}
              </span>
            )}
          </div>
        </div>

        <div className="tc-content">
          {loading ? (
            <div style={{ padding: "20px", textAlign: "center" }}>Loading...</div>
          ) : tcTab === "preview" ? (
            <PolicyListing list={list} defaultTitle={policyTitle} />
          ) : (
            <PolicyCreate
              list={list}
              token={token}
              endpoint={endpoint}
              policyTitle={policyTitle}
              activeterms={activeterms}
              setTcTab={setTcTab}
              onRefresh={fetchPolicy}
            />
          )}
        </div>
      </div>
    );
  };

  const ContactUsListing = ({ data }) => {
    if (!data)
      return (
        <div className="tc-listing">
          <p>No Contact Us details found.</p>
        </div>
      );

    return (
      <div className="contact-us-listing">
        <h3>{data.heading || "Contact Us"}</h3>
        {data.content && (
          <p style={{ color: "#555", marginBottom: "20px" }}>{data.content}</p>
        )}

        <div className="contact-card-grid">
          <div className="contact-card">
            <label>Email Address</label>
            <p>
              <a href={`mailto:${data.email}`}>{data.email || "N/A"}</a>
            </p>
          </div>

          <div className="contact-card">
            <label>Phone Number</label>
            <p>
              <a href={`tel:${data.phone}`}>{data.phone || "N/A"}</a>
            </p>
          </div>

          <div className="contact-card">
            <label>WhatsApp</label>
            <p>{data.whatsapp || "N/A"}</p>
          </div>

          <div className="contact-card">
            <label>Working Hours</label>
            <p>{data.workingHours || "N/A"}</p>
          </div>

          <div className="contact-card" style={{ gridColumn: "span 2" }}>
            <label>Address</label>
            <p>{data.address || "N/A"}</p>
          </div>

          {data.mapLink && (
            <div className="contact-card" style={{ gridColumn: "span 2" }}>
              <label>Map Link</label>
              <p>
                <a href={data.mapLink} target="_blank" rel="noopener noreferrer">
                  {data.mapLink}
                </a>
              </p>
            </div>
          )}
        </div>
      </div>
    );
  };

  const ContactUsCreate = ({ data, token, setTcTab, onRefresh }) => {
    const [form, setForm] = useState({
      heading: data?.heading || "Contact Us",
      content: data?.content || "",
      email: data?.email || "",
      phone: data?.phone || "",
      whatsapp: data?.whatsapp || "",
      address: data?.address || "",
      mapLink: data?.mapLink || "",
      workingHours: data?.workingHours || "",
    });

    const handleSave = async () => {
      try {
        if (data?._id) {
          const response = await putWithTokenAPI(
            token,
            `/contact-us/update/${data._id}`,
            form
          );
          if (response?.statusCode === 200 || response?.status === "success") {
            toast.success("Contact Us updated successfully");
            onRefresh && onRefresh();
            setTcTab("preview");
          } else {
            toast.error(response?.message || "Failed to update Contact Us");
          }
        } else {
          const response = await postWithTokenAPI(
            token,
            "/contact-us/create",
            form
          );
          if (response?.statusCode === 200 || response?.status === "success") {
            toast.success("Contact Us created successfully");
            onRefresh && onRefresh();
            setTcTab("preview");
          } else {
            toast.error(response?.message || "Failed to create Contact Us");
          }
        }
      } catch (error) {
        console.error("Error updating Contact Us:", error);
        toast.error("Failed to update Contact Us");
      }
    };

    return (
      <div className="editor-container minimalist">
        <div className="tc-create-container">
          <h3>
            {data?._id ? "Edit Contact Us Details" : "Create Contact Us Details"}
          </h3>

          <form className="profiledataupdateform" style={{ maxWidth: "100%" }}>
            <div className="two-col">
              <div className="form-groupp">
                <label>Heading</label>
                <input
                  type="text"
                  value={form.heading}
                  onChange={(e) => setForm({ ...form, heading: e.target.value })}
                />
              </div>
              <div className="form-groupp">
                <label>Working Hours</label>
                <input
                  type="text"
                  value={form.workingHours}
                  onChange={(e) =>
                    setForm({ ...form, workingHours: e.target.value })
                  }
                />
              </div>
            </div>

            <div className="two-col">
              <div className="form-groupp">
                <label>Email Address</label>
                <input
                  type="email"
                  value={form.email}
                  onChange={(e) => setForm({ ...form, email: e.target.value })}
                />
              </div>
              <div className="form-groupp">
                <label>Phone Number</label>
                <input
                  type="text"
                  value={form.phone}
                  onChange={(e) => setForm({ ...form, phone: e.target.value })}
                />
              </div>
            </div>

            <div className="two-col">
              <div className="form-groupp">
                <label>WhatsApp Number</label>
                <input
                  type="text"
                  value={form.whatsapp}
                  onChange={(e) => setForm({ ...form, whatsapp: e.target.value })}
                />
              </div>
              <div className="form-groupp">
                <label>Google Maps Link</label>
                <input
                  type="text"
                  value={form.mapLink}
                  onChange={(e) => setForm({ ...form, mapLink: e.target.value })}
                />
              </div>
            </div>

            <div className="form-groupp">
              <label>Content Description</label>
              <textarea
                className="form-textarea"
                value={form.content}
                onChange={(e) => setForm({ ...form, content: e.target.value })}
              />
            </div>

            <div className="form-groupp">
              <label>Address</label>
              <textarea
                className="form-textarea"
                value={form.address}
                onChange={(e) => setForm({ ...form, address: e.target.value })}
              />
            </div>

            <div
              style={{
                display: "flex",
                justifyContent: "flex-end",
                marginTop: "20px",
              }}
            >
              <button
                type="button"
                className="btn btn-success"
                onClick={handleSave}
              >
                {data?._id ? "Update Contact Us" : "Save Contact Us"}
              </button>
            </div>
          </form>
        </div>
      </div>
    );
  };

  const ContactUsManager = ({ token, permission }) => {
    const [tcTab, setTcTab] = useState("preview");
    const [contactData, setContactData] = useState(null);
    const [loading, setLoading] = useState(false);

    const fetchContactData = async () => {
      setLoading(true);
      try {
        const response = await getWithTokenAPI(token, "/contact-us/list");
        if (response?.statusCode === 200 && response?.data) {
          const item = Array.isArray(response.data)
            ? response.data[0]
            : response.data;
          setContactData(item || null);
        } else {
          setContactData(null);
        }
      } catch (error) {
        console.error("Error fetching Contact Us:", error);
        setContactData(null);
      } finally {
        setLoading(false);
      }
    };

    useEffect(() => {
      fetchContactData();
    }, [token]);

    return (
      <div className="tc-wrapper">
        <div className="tc-tabs">
          <div className="tc-tabs-child">
            <span
              className={tcTab === "preview" ? "tc-tab active" : "tc-tab"}
              onClick={() => setTcTab("preview")}
            >
              Preview
            </span>

            {permission?.logoandtermsCondition?.update && (
              <span
                className={tcTab === "create" ? "tc-tab active" : "tc-tab"}
                onClick={() => setTcTab("create")}
              >
                {contactData?._id ? "Edit" : "Create"}
              </span>
            )}
          </div>
        </div>

        <div className="tc-content">
          {loading ? (
            <div style={{ padding: "20px", textAlign: "center" }}>Loading...</div>
          ) : tcTab === "preview" ? (
            <ContactUsListing data={contactData} />
          ) : (
            <ContactUsCreate
              data={contactData}
              token={token}
              setTcTab={setTcTab}
              onRefresh={fetchContactData}
            />
          )}
        </div>
      </div>
    );
  };
  const mapProfileToForm = (profiledata) => {
    return {
      // ===== BASIC DETAILS =====
      fullName: profiledata?.name || "",
      mobile: profiledata?.phoneNumber || "",
      email: profiledata?.email || "",
      profileImage: profiledata?.profileimage || "",
      pincode: profiledata?.location1?.[0]?.pincode || "",
      state: profiledata?.location1?.[0]?.state
        ? {
            label: profiledata?.location1?.[0].state,
            value: profiledata?.location1?.[0].state,
          }
        : null,

      district: profiledata?.location1?.[0]?.city
        ? {
            label: profiledata?.location1?.[0].city,
            value: profiledata?.location1?.[0].city,
          }
        : null,

      bankname: profiledata?.driverDetails?.bankDetails?.bankName || "",
      accountnumber: profiledata?.driverDetails?.bankDetails?.accountNo || "",
      accountholdername:
        profiledata?.driverDetails?.bankDetails?.accountHolderName || "",
      accounttype: profiledata?.driverDetails?.bankDetails?.accountType || "",
      ifsc: profiledata?.driverDetails?.bankDetails?.ifscCode || "",
    };
  };
  const handleUpdatelogo = async (url) => {
    try {
      const payload = { logo: url };
      const response = await putWithTokenAPI(token, `/logo/${logoid}?type=${logoType.value}`, payload);
      if (response?.statusCode === 200 || response?.status === "success") {
        toast.success("Logo Updated Successfully");
      }
    } catch (error) {
      console.error("Failed to update logo:", error);
    }
  };

  const uploadImage = async (file) => {
    const formData = new FormData();
    formData.append("files", file);

    const res = await postWithoutTokenAPI(
      `/upload_image?userId=${adminId}&type=admin`,
      formData,
      true,
    );

    return res?.data?.[0]?.fileUrl;
  };

  const handleProfileImage = async (e) => {
    const file = e.target.files[0];
    if (!file) return;

    const url = await uploadImage(file);
    setForm((prev) => ({ ...prev, profileImage: url }));
    // handleUpdate("details");
    // toast.success("Profile Image Updated Successfuly");
  };
  const handlelogoImage = async (e) => {
    const file = e.target.files[0];
    if (!file) return;

    const url = await uploadImage(file);
    setApplogo(url);
    handleUpdatelogo(url);
    toast.success("Logo Updated Successfuly");
  };
  const validateForm = (section) => {
    const newErrors = {};

    if (section === "details") {
      if (!nameRegex.test(form.fullName))
        newErrors.fullName = "Enter a valid name";

      if (!phoneRegex.test(form.mobile))
        newErrors.mobile = "Enter valid mobile number";

      if (!emailRegex.test(form.email)) newErrors.email = "Enter valid email";

      if (!form.district) newErrors.district = "Select city";
      if (!form.state) newErrors.state = "Select state";
    }

    if (section === "bank") {
      if (!nameRegex.test(form.accountholdername))
        newErrors.accountholdername = "Invalid name";

      if (!accountRegex.test(form.accountnumber))
        newErrors.accountnumber = "Invalid account number";

      if (!ifscRegex.test(form.ifsc)) newErrors.ifsc = "Invalid IFSC code";
    }

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const validatePasswordForm = () => {
    const newErrors = {};

    if (!pswd || pswd.length < 8) {
      newErrors.pswd = "Password must be at least 8 characters";
    }

    if (pswd !== cpswd) {
      newErrors.cpswd = "Passwords do not match";
    }

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleUpdate = async (section) => {
    if (section !== "password" && !validateForm(section))
      toast.error("validation Error");
    if (section === "password" && !validatePasswordForm())
      toast.error("Validation Error");

    setLoading(true);

    const payload = {
      name: form.fullName,
      email: form.email,
      phoneNumber: form.mobile,
      logo: form.logo,
      profileimage: form.profileImage,

      password: section === "password" ? pswd : undefined,

      location1: [
        {
          city: form.district?.value || "",
          state: form.state?.value || "",
          pincode: form?.pincode || "",
        },
      ],

      driverDetails: {
        bankDetails: {
          bankName: form.bankname || "",
          accountNo: form.accountnumber || "",
          ifscCode: form.ifsc || "",
          accountHolderName: form.accountholdername || "",
          accountType: form.accounttype || "",
        },
      },
    };

    try {
      const response = await putWithTokenAPI(
        token,
        `/user/update/${adminId}`,
        payload,
      );
      console.log(payload, "PAYLOAD");
      if (response?.data) {
        console.log("Updation Success");
        onApproveSuccess?.();
        {
          section === "password"
            ? toast.success("Password changed Successfully")
            : toast.success("Profile Updated Successfully");
        }
      } else {
        console.log("Updation failed");
        {
          section === "password"
            ? toast.error("Password Chnage Unsuccessful")
            : toast.error("Profile Updation Failed");
        }
      }
    } catch (err) {
      console.log("Profile Updation failed");
      console.error(err);
      toast.error(err);
    } finally {
      setLoading(false);
    }
  };

  const customStyles = {
    control: (base, state) => ({
      ...base,
      // Height: "34px",
      padding: "0px",
      // width: "160px",
      // minWidth: "160px",
      // maxWidth: "160px",
      overflow: "auto",
      border: "0.6px solid #dcdcdc",
      borderRadius: "4px",
      boxShadow: state.isFocused ? "0 0 0 2px rgba(74, 144, 226, 0.2)" : "none",
      borderColor: state.isFocused ? "#4a90e2" : "#dcdcdc",
      "&:hover": {
        borderColor: "#999",
      },
      backgroundColor: "white",
    }),
    option: (base, state) => {
      const isSelected = state.isSelected;
      const isFocused = state.isFocused;

      return {
        ...base,
        backgroundColor: isSelected
          ? "#013A28" // ✅ selected always wins
          : isFocused
            ? "#02543a53" // hover only for non-selected
            : "white",
        color: isSelected ? "white" : "#333",
        cursor: "pointer",

        // ❌ disable hover override on selected
        ":hover": {
          backgroundColor: isSelected ? "#013A28" : "#02543a53",
        },

        ":active": {
          backgroundColor: isSelected ? "#013A28" : "#02543a53",
        },
      };
    },

    menu: (base) => ({
      ...base,
      borderRadius: "4px",
      boxShadow: "0 4px 12px rgba(0, 0, 0, 0.1)",
      zIndex: "99 !important",
    }),
    menuList: (base) => ({
      ...base,
      padding: 0,
      maxHeight: "180px",
      overflow: "auto",
      // Scrollbar matching your #8C1007 theme
      "&::-webkit-scrollbar": {
        width: "6px",
      },
      "&::-webkit-scrollbar-track": {
        background: "#013a284a",
        borderRadius: "3px",
      },
      "&::-webkit-scrollbar-thumb": {
        background: "#013a2840",
        borderRadius: "3px",
      },
      "&::-webkit-scrollbar-thumb:hover": {
        background: "#013a2851",
      },
      scrollbarWidth: "thin",
      scrollbarColor: "#02543a53 #b0b0b06a",
    }),
    singleValue: (base) => ({
      ...base,
      color: "rgb(99, 99, 99)", // Matching your color
      fontSize: "14px",
      fontWeight: "500",
      // margin: 0,
      paddingLeft: "10px",

      top: "0", // remove translate centering
      transform: "none",
    }),
    placeholder: (base) => ({
      ...base,
      color: "#acacac",
      fontSize: "14px",
      fontWeight: "500",
    }),
    dropdownIndicator: (base) => ({
      ...base,
      color: "#8c8c8c",
      padding: "4px 8px",
      "&:hover": {
        color: "#666",
      },
    }),
    indicatorSeparator: () => ({
      display: "none",
    }),
    valueContainer: (base) => ({
      ...base,
      padding: "2px 5px",
      // height: "34px",
    }),
  };

  return (
    <div className="personalinfo">
      {/* ===== TABS ===== */}
      <div className="tabs">
        {["details", "password", "bank"].map((tab) => (
          <span
            key={tab}
            className={activeTab === tab ? "active" : ""}
            onClick={() => setActiveTab(tab)}
          >
            {tab === "details"
              ? "Personal Details"
              : tab === "password"
              ? "Password"
              : "Bank Account"}
          </span>
        ))}
      </div>

      {/* ================= PERSONAL DETAILS ================= */}
      {activeTab === "details" && (
        <>
          <div className="profileimg-wrapper">
            <div className="personalprofile">
              <img src={form?.profileImage} alt="profile" />
            </div>

            <button
              className="upload-btn"
              onClick={() => profileFileRef.current.click()}
            >
              <img src={camera} className="cameraimg" alt="camera"></img>
              Update Profile Image
            </button>

            <input
              type="file"
              hidden
              ref={profileFileRef}
              onChange={handleProfileImage}
            />
          </div>

          <form className="profiledataupdateform">
            <div className="form-groupp">
              <label>Full Name</label>
              <input
                type="text"
                value={form.fullName}
                onChange={(e) => setForm({ ...form, fullName: e.target.value })}
              />
              {errors.fullName && (
                <span className="error-text">{errors.fullName}</span>
              )}
            </div>

            <div className="form-groupp">
              <label>Mobile Number</label>
              <input
                type="text"
                value={form.mobile}
                onChange={(e) => setForm({ ...form, mobile: e.target.value })}
              />
              {errors.mobile && (
                <span className="error-text">{errors.mobile}</span>
              )}
            </div>

            <div>
              <label>Email Address</label>
              <input type="email" value={form.email} disabled />
            </div>

            <div className="select-row">
              <div>
                <label>State</label>
                <Select
                  value={form.state}
                  options={states}
                  styles={customStyles}
                  onChange={(val) => {
                    setForm({ ...form, state: val, district: null });
                    fetchDistricts(val.value);
                  }}
                  isSearchable
                  menuPlacement="top"
                />
              </div>
              <div>
                <label>City</label>
                <Select
                  value={form.district}
                  options={districts}
                  styles={customStyles}
                  onChange={(val) => setForm({ ...form, district: val })}
                  isSearchable
                  menuPlacement="top"
                />
              </div>
              <div className="form-groupp" style={{ width: "90%" }}>
                <label>Pincode</label>
                <input
                  type="number"
                  value={form?.pincode}
                  onChange={(e) =>
                    setForm({ ...form, pincode: e.target.value })
                  }
                />
                {errors.pincode && (
                  <span className="error-text">{errors.pincode}</span>
                )}
              </div>
            </div>

            <button
              type="button"
              className="save-btn"
              onClick={() => handleUpdate("details")}
            >
              Update Savings
            </button>
          </form>
        </>
      )}

      {/* ================= PASSWORD ================= */}
      {activeTab === "password" && (
        <div className="password-section">
          <h1>Reset Password</h1>
          <span className="resettext">Please type something you remember</span>
          <label className="plabel" style={{ marginTop: "3vh" }}>
            New Password
          </label>
          <div className="password-input">
            <input
              type={showNew ? "text" : "password"}
              placeholder="Must be 8 characters"
              value={pswd}
              onChange={(e) => setPswd(e.target.value)}
            />
            <span onClick={() => setShowNew(!showNew)}>
              {!showNew ? <FaRegEyeSlash /> : <FaRegEye />}
            </span>
            {errors.pswd && <span className="error-text">{errors.pswd}</span>}
          </div>

          <label className="plabel">Confirm Password</label>
          <div className="password-input">
            <input
              type={showConfirm ? "text" : "password"}
              placeholder="Repeat Password"
              value={cpswd}
              onChange={(e) => setCPswd(e.target.value)}
            />
            <span onClick={() => setShowConfirm(!showConfirm)}>
              {!showConfirm ? <FaRegEyeSlash /> : <FaRegEye />}
            </span>
          </div>
          {errors.cpswd && <span className="error-text">{errors.cpswd}</span>}

          <button
            type="button"
            className="reset-btn"
            onClick={() => {
              if (validatePasswordForm()) {
                setOtpOpen(true);
              }
            }}
          >
            Reset password
          </button>
        </div>
      )}

      {/* BANK ACCOUNT */}
      {activeTab === "bank" && (
        <>
          <form className="profiledataupdateform">
            <div className="two-col">
              <div className="form-groupp">
                <label>Bank Name</label>
                <input
                  type="text"
                  value={form.bankname}
                  onChange={(e) =>
                    setForm({ ...form, bankname: e.target.value })
                  }
                />
                {errors.bankname && (
                  <span className="error-text">{errors.bankname}</span>
                )}
              </div>

              <div className="form-groupp">
                <label>Account Number</label>
                <input
                  type="number"
                  value={form.accountnumber}
                  onChange={(e) =>
                    setForm({ ...form, accountnumber: e.target.value })
                  }
                />
                {errors.accountnumber && (
                  <span className="error-text">{errors.accountnumber}</span>
                )}
              </div>
            </div>
            <div className="two-col">
              <div className="form-groupp">
                <label>Account Holder Name</label>
                <input
                  type="text"
                  value={form.accountholdername}
                  onChange={(e) =>
                    setForm({ ...form, accountholdername: e.target.value })
                  }
                />
                {errors.accountholdername && (
                  <span className="error-text">{errors.accountholdername}</span>
                )}
              </div>

              <div className="form-groupp">
                <label>Account Type</label>
                <input
                  type="text"
                  value={form.accounttype}
                  onChange={(e) =>
                    setForm({ ...form, accounttype: e.target.value })
                  }
                />
                {errors.accounttype && (
                  <span className="error-text">{errors.accounttype}</span>
                )}
              </div>
            </div>
            <div className="specialcode">
              <label>IFSC Code</label>
              <input
                type="text"
                value={form.ifsc}
                onChange={(e) => setForm({ ...form, ifsc: e.target.value })}
              />
              {errors.ifsc && <span className="error-text">{errors.ifsc}</span>}
            </div>

            <button
              type="button"
              className="save-btn"
              onClick={() => handleUpdate("bank")}
            >
              Update Savings
            </button>
          </form>
        </>
      )}
      <OtpModal
        open={otpOpen}
        onClose={() => setOtpOpen(false)}
        phone={form?.mobile}
        onOtpSuccess={() => handleUpdate("password")}
      />
    </div>
  );
};

export default Personalinfo;
